import { render, staticRenderFns } from "./trustPaymentJs.vue?vue&type=template&id=6c72ee84"
import script from "./trustPaymentJs.vue?vue&type=script&lang=js"
export * from "./trustPaymentJs.vue?vue&type=script&lang=js"
import style0 from "./trustPaymentJs.vue?vue&type=style&index=0&id=6c72ee84&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports